<!-- Header: Defines product name and admin options that display in header -->
<jha-header [jhaIsHidden]="hideHeader">
  <!-- Left side -->
  <jha-header-left
    [jhaDisplayBackButton]="displayBackButton"
    (jhaBackButtonClicked)="backButtonClicked()">
    <!-- Product name -->
    <jha-header-title jhaTitle="PowerFrame Design Portal"></jha-header-title>
  </jha-header-left>

  <!-- Right side -->
  <jha-header-right *ngIf="loggedIn">
    <!-- Institutions -->
    <jha-header-dropdown
      *ngIf="wksList.length < 13"
      jhaIconType="Bank"
      jhaText="{{ currentWKSInst }}"
      jhaTooltip="Select Institution">
      <jha-header-dropdown-option
        *ngFor="let inst of wksList; let i = index"
        (click)="switchWks(inst)"
        jhaText="{{ inst.institutionId }}">
      </jha-header-dropdown-option>
    </jha-header-dropdown>

    <jha-header-mega-menu
      *ngIf="wksList.length > 12"
      jhaIconType="Bank"
      jhaText="{{ currentWKSInst }}"
      jhaTooltip="Select Institution">
      <jha-mega-menu-item
        *ngFor="let inst of wksList; let i = index"
        (click)="switchWks(inst)"
        jhaText="{{ inst.institutionId }}">
      </jha-mega-menu-item>
    </jha-header-mega-menu>
    <!-- Profile -->
    <jha-header-dropdown
      data-test="userOptions"
      jhaIconType="Person"
      jhaText="User"
      jhaTooltip="User Options">
      <jha-header-dropdown-option
        jhaText="Profile"
        (click)="showUserProfile()"></jha-header-dropdown-option>
      <jha-header-dropdown-option
        data-test="userOptionsLogout"
        jhaText="Log Out"
        (click)="logOut()"></jha-header-dropdown-option>
    </jha-header-dropdown>
  </jha-header-right>
</jha-header>
